import React, { useContext, useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation } from "react-router-dom";
// import ThemeToggleButton from "../helper/ThemeToggleButton";
import { LoginContext } from "../AuthContext/LoginContext";
//import logo from '/assets/images/logo/forest_logo_fw.png';
import { TypingAnimation } from "../components/magicui/typing-animation.tsx";
import { formatDcfText } from "../utils/displayText";


const MasterLayout = ({ children }) => {
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation(); // Hook to get the current route
  const { logout, user, hasPermission } = useContext(LoginContext);
 

  // Send this userId to your backend to associate with your user
  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
            ? "sidebar sidebar-open"
            : "sidebar"
        }
        style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh / 0.8)' }}
      >
        <button
          onClick={mobileMenuControl}
          type='button'
          className='sidebar-close-btn'
        >
          <Icon icon='radix-icons:cross-2' />
        </button>
        <div className='sidebar-logo-fixed text-center pt-3 pb-4 bg-inherit' style={{ flexShrink: 0 }}>
            <Link to='/' className='d-block'>
              <div className="flex items-center justify-content-center">
                <img 
                  src={process.env.PUBLIC_URL + "/assets/images/logo1.png"}
                  alt="Logo" 
                  className="mx-4" 
                  style={{ width: '240px', height: 'auto' }} 
                />
              </div>
            </Link>
            <hr className="my-3 mx-4" style={{ height: "3px", backgroundColor: "white", opacity: 1 }} />
        </div>
        
        <div className='sidebar-menu-area overflow-auto' style={{ flex: 1, height: 'auto' }}>
          {/* <ul className='sidebar-menu' id='sidebar-menu'>
              <li>
                  <NavLink
                      to='/dashboard'
                      className={(navData) =>
                          navData.isActive ? "active-page" : ""
                      }
                  >
                      <Icon icon="mdi:view-dashboard" className="menu-icon" /> 
                      <span>Dashboard</span>
                  </NavLink>
              </li>
               <li>
                  <NavLink
                      to='/complains/add'
                      className={(navData) =>
                          navData.isActive ? "active-page" : ""
                      }
                  >
                      <Icon icon="mdi:comment-alert-outline" className="menu-icon" /> 
                      <span>Complaint Form</span>
                  </NavLink>
              </li> 
              <li>
                  <NavLink
                      to='/complains/list'
                      className={(navData) =>
                          navData.isActive ? "active-page" : ""
                      }
                  >
                      <Icon icon="mdi:format-list-bulleted" className="menu-icon" />
                      <span>Complains List</span>
                  </NavLink>
              </li>
              <li>
                  <NavLink
                      to='/users/add'
                      className={(navData) =>
                          navData.isActive ? "active-page" : ""
                      }
                  >
                      <Icon icon="mdi:account-plus" className="menu-icon" />
                      <span>Add User</span>
                  </NavLink>
              </li>
              <li>

                  <NavLink
                      to='/users/list'
                      className={(navData) =>
                          navData.isActive ? "active-page" : ""
                      }
                  >
                      <Icon icon="mdi:account-plus" className="menu-icon" />
                      <span>View Users</span>
                  </NavLink>
              </li>
              <li>

              <NavLink
                  to='/dfos-list'
                  className={(navData) =>
                      navData.isActive ? "active-page" : ""
                  }
              >
                  <Icon icon="mdi:map-marker" className="menu-icon" />
                  <span>Directory</span>
              </NavLink>
              </li>
              <li className='dropdown'>
                <Link to='#'>
                  <Icon
                    icon='solar:hand-heart-outline'  
                    className='menu-icon'
                  />
                  <span>Rescuers</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/rescures/add'  
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />
                      Add Rescuers
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to='/rescures/list' 
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-warning-main w-auto' />
                      Rescuers List
                    </NavLink>
                  </li>
                </ul>
              </li>
          </ul> */}
          <ul className='sidebar-menu pb-5' id='sidebar-menu'>
            {hasPermission('dashboard-volunteer', 'view') && (
              <li className="py-10">
                <NavLink
                  to='/dashboard-volunteers'
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:view-dashboard" className="menu-icon" /> 
                  <span>Volunteers Dashboard</span>
                </NavLink>
              </li>
            )}
            
             {hasPermission('dashboard', 'view') && (
              <li className="py-10">
                <NavLink
                  to='/dashboard'
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:view-dashboard" className="menu-icon" /> 
                  <span>Dashboard</span>
                </NavLink>
              </li>
            )}
            
            {hasPermission('complaints', 'create') && (
              <li className="py-10">
                <NavLink
                  to='/complains/add'
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:comment-alert-outline" className="menu-icon" /> 
                  <span>Complaint Form</span>
                </NavLink>
              </li>
            )}
            
            {hasPermission('lead_dispatch', 'view') && (
              <li className="py-10">
                <NavLink
                  to='/dispatch/list'
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:format-list-bulleted" className="menu-icon" />
                  <span>Dispatch List</span>
                </NavLink>
              </li>
            )}
          {hasPermission('lead_close', 'view') && (
              <li className="py-10">
                <NavLink
                  to='/closed/list'
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:format-list-bulleted" className="menu-icon" />
                  <span>Reply Submitted List</span>
                </NavLink>
              </li>
            )}
          {hasPermission('lead_close', 'view') && (
              <li className="py-10">
                <NavLink
                  to='/reopen/list'
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:lock-reset" className="menu-icon" />
                  <span>Re-Open List</span>
                </NavLink>
              </li>
            )}
            {hasPermission('complaints', 'view') && (
              <li className="py-10">
                <NavLink
                  to='/complains/list'
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:format-list-bulleted" className="menu-icon" />
                  <span>Complaints List</span>
                </NavLink>
              </li>
            )}
            {hasPermission('complaints', 'view') && (
              <li className="py-10">
                <NavLink
                  to='/informative-calls'
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:phone-in-talk-outline" className="menu-icon" />
                  <span>Informative Calls</span>
                </NavLink>
              </li>
            )}
            {hasPermission('complaints', 'view') && (
              <li className="py-10">
                <NavLink
                  to='/escalated-complaints'
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:alert-octagon-outline" className="menu-icon" />
                  <span>Escalated Complaints</span>
                </NavLink>
              </li>
            )}


            {hasPermission('reports', 'view') && (
              <li className='dropdown '>
                <Link to='#'>
                  <Icon
                    icon='solar:hand-heart-outline'  
                    className='menu-icon'
                  />
                  <span>Reports</span>
                </Link>
                <ul className='sidebar-submenu'>
                  
                  {hasPermission('reports', 'view') && (
                    <li className="py-6">
                      <NavLink
                        to='/reports/performance' 
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className='ri-circle-fill circle-icon text-success-main w-auto' />
                        Performance 
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {(hasPermission('rescuers', 'view') || hasPermission('rescuers', 'create')) && (
              <li className='dropdown py-10'>
                <Link to='#'>
                  <Icon
                    icon='solar:hand-heart-outline'  
                    className='menu-icon'
                  />
                  <span>Rescuers</span>
                </Link>
                <ul className='sidebar-submenu'>
                  {hasPermission('rescuers', 'create') && (
                    <li className="py-6">
                      <NavLink
                        to='/rescures/add'  
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />
                        Add Rescuers
                      </NavLink>
                    </li>
                  )}
                  {hasPermission('rescuers', 'view') && (
                    <li className="py-6">
                      <NavLink
                        to='/rescures/list' 
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className='ri-circle-fill circle-icon text-warning-main w-auto' />
                        Rescuers List
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {hasPermission('dfo_list', 'view') && (
              <li className="py-10">
                <NavLink
                  to='/dfos-list'
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:map-marker" className="menu-icon" />
                  <span>Directory</span>
                </NavLink>
              </li>
            )}
            {hasPermission('dashboard-volunteer', 'view') && (
              <li className="py-10">
                <NavLink
                  to='/volunteer-list'
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:map-marker" className="menu-icon" />
                  <span>Volunteers List</span>
                </NavLink>
              </li>
            )}

            {hasPermission('users', 'view') && (
              <>
                <li className="py-10">
                  <NavLink
                    to='/users/add'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="mdi:account-plus" className="menu-icon" />
                    <span>Add User</span>
                  </NavLink>
                </li>
                <li className="py-10">
                  <NavLink
                    to='/users/list'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="mdi:account-plus" className="menu-icon" />
                    <span>Users List</span>
                  </NavLink>
                </li>
                <>
                
                
                {/* <li className="py-10">
                  <Link
                    to='/contact-us'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="solar:phone-linear" className="menu-icon" />
                    <span>Contact Us</span>
                  </Link>
                </li> */}
              </>
          
              
              </>
            )}
            {hasPermission('custom_users', 'view') && (
              <li className="py-10">
                <NavLink to="/custom-users" className={(navData) => navData.isActive ? "active-page" : ""}>
                  <Icon icon="mdi:account-tree" className="menu-icon" />
                  <span>Custom User</span>
                </NavLink>
              </li>
            )}
            {hasPermission('complaint_nature', 'view') && (
              <li className="dropdown">
                <Link to='#'>
                  <Icon icon="solar:settings-outline" className="menu-icon" />
                  <span>Settings</span>
                </Link>
                <ul className="sidebar-submenu">
                  <li>
                    <NavLink
                      to='/complaint-natures'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />
                      Nature of Complaints
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
            <>
                <li className="py-10">
                  <Link
                    to='/change-password'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="solar:user-linear" className="menu-icon" />
                    <span>Change Password</span>
                  </Link>
                </li>
                <li className="py-10">
                  <Link
                    onClick={logout}
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="lucide:power" className="menu-icon" />
                    <span>Log Out</span>
                  </Link>
                </li>
              </>
           
             
            
            
          </ul>
      </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div
          className="navbar-header"
          style={{
          position: 'relative', // needed for absolute positioning of video and overlay
          overflow: 'hidden',   // to clip video if needed
        }}
        >
           {/* Video background */}
        <video
          autoPlay
          loop
          muted
          playsInline
          src={process.env.PUBLIC_URL + "/assets/videos/video_forest_top_bar.mp4"}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 0,
          }}
        />
        <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 255, 0, 0.03)', // Green overlay with transparency
              zIndex: 1,
            }}
          ></div>
          <div style={{ position: 'relative', zIndex: 2 }}>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-4'>
                <button
                  type='button'
                  className='sidebar-toggle'
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon='iconoir:arrow-right'
                      className='icon text-2xl non-active'
                    />
                  ) : (
                    <Icon
                      icon='heroicons:bars-3-solid'
                      className='icon text-2xl non-active '
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type='button'
                  className='sidebar-mobile-toggle'
                >
                  <Icon icon='heroicons:bars-3-solid' className='icon' />
                </button>
              </div>
            </div>
            <div className='col-auto'>
              <div className="d-flex flex-wrap align-items-center">
                <label className="d-flex align-items-center" style={{ cursor: "pointer" }}>
                  
                  {/* Full name for larger screens */}
                  {/* <span
                    className="ps-4 fs-5 fw-semibold text-uppercase d-none d-md-inline sm:text-xs"
                    style={{ letterSpacing: "0.5px", color: "#2c3e50" }}
                  >
                    Forestry & Wildlife Department
                  </span> */}
                  {/* Full name for mobile screens with smaller font size */}
                  <TypingAnimation 
                              startOnView={true}
                              style={{
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 700,
                                fontSize: "35px",
                                background: "linear-gradient(to right, #eebb12ff, #ffc60bff, #ffcc00ff)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                backgroundClip: "text",
                              }}
                            >
                    {hasPermission('dashboard-volunteer', 'view')
                      ? "Green Volunteer Management System of FW&F"
                      : "CENTRALIZED COMPLAINT MANAGEMENT SYSTEM"}
                 </TypingAnimation>
                </label>
              </div>
            </div>
            <div className='col-auto'>
              
              <div className='d-flex flex-wrap align-items-center gap-3'>

                {/* Logged-in user's designation — a compact pill next to the profile. */}
                {user?.designation && (
                  <div
                    className='d-none d-sm-flex align-items-center gap-2 px-12 py-6 radius-8 bg-primary-50 border border-primary-100'
                    title={`${user.first_name || ''} ${user.last_name || ''} — ${formatDcfText(user.designation)}`}
                  >
                    <span className='d-flex justify-content-center align-items-center w-32-px h-32-px rounded-circle bg-primary-600 text-white flex-shrink-0'>
                      <Icon icon='solar:user-id-bold' className='icon text-lg' />
                    </span>
                    <div className='d-flex flex-column lh-1'>
                      <span className='text-primary-light fw-semibold text-sm text-truncate' style={{ maxWidth: '220px' }}>
                        {formatDcfText(user.designation)}
                      </span>
                      <span className='text-secondary-light fw-medium' style={{ fontSize: '11px' }}>
                        {user.first_name} {user.last_name}
                      </span>
                    </div>
                  </div>
                )}

                {/* ThemeToggleButton */}
                {/* <ThemeToggleButton /> */}
                {/* Notification dropdown end */}
                <div className='dropdown'>
                  <button
                    className='d-flex justify-content-center align-items-center rounded-circle'
                    type='button'
                    data-bs-toggle='dropdown'
                  >
                 
                    
                  </button>
                  <div className='dropdown-menu to-top dropdown-menu-sm'>
                    <div className='py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                      <div>
                        <h6 className='text-lg text-primary-light fw-semibold mb-2'>
                        {user.first_name } {user.last_name}
                        </h6>
                        {user.designation && (
                          <span className='d-block text-primary-light fw-medium text-sm mb-1'>
                          {formatDcfText(user.designation)}
                          </span>
                        )}
                        <span className='text-secondary-light fw-medium text-sm'>
                        {user.role }
                        </span>
                      </div>
                      <button type='button' className='hover-text-danger'>
                        <Icon
                          icon='radix-icons:cross-1'
                          className='icon text-xl'
                        />
                      </button>
                    </div>
                    <ul className='to-top-list'>
                      <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'
                          to='/change-password'
                        >
                          <Icon
                            icon='solar:user-linear'
                            className='icon text-xl'
                          />
                          Change Password
                        </Link>
                      </li>
                      <li>
                        <Link onClick={logout}
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3'
                          to='#'
                        >
                          <Icon icon='lucide:power' className='icon text-xl' />{" "}
                          Log Out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className='dashboard-main-body'>
          {children}
          </div>

        {/* Footer section */}
        <footer className='d-footer py-3 bg-light border-top'>
        <div className='container'>
          <div className='row align-items-center justify-content-between'>
            {/* Copyright Text */}
            <div className='col-auto'>
              <p className='mb-0 text-muted fs-6'>
                © {new Date().getFullYear()} Forestry & Wildlife. All Rights Reserved.
              </p>
            </div>

            {/* Developer Credit */}
            <div className='col-auto'>
              <p className='mb-0 text-muted fs-6'>
                Developed by <span className='text-success-700 fw-semibold'>GIS Lab | Forest & Wildlife Department | Punjab, Pakistan</span>
              </p>
            </div>
          </div>
        </div>
      </footer>
      </main>
    </section>
  );
};

export default MasterLayout;
